<template lang="pug">
    transition(name="modal")
        .modal-mask()
                .modal-wrapper
                    .modal-container(v-if="sync")
                        button(@click="closeModal()").float-right.closeBtn Close this window
                        h5().bolder.mt-5 Sync Logs
                        .row
                            .col-6 
                                b Sync name: <br>
                                | {{sync.name}}
                            .col-6 
                                b Sync type: <br>
                                | {{sync.source.name}} &gt; {{sync.destination.name}}
                        table.w-100.mt-5.table.table-striped
                            thead
                                th Date 
                                th(v-if="sync.direction == 'in'") Imported Rows 
                                th(v-if="sync.direction == 'out'") Exported Rows 
                                th(v-if="sync.direction == 'in'") Updated Products 
                                th(v-if="sync.direction == 'in'") Synced Products
                                th(v-if="sync.direction == 'in'") Skipped Rows
                                th(v-if="sync.direction == 'out'") Sent To Destination
                                th(v-if="sync.direction == 'out'") Sent File
                                th(v-if="sync.direction == 'in'") Source File
                                th(v-if="sync.direction == 'in'") Detailed Importer Log
                                th Errors
                            tbody
                                tr(v-for="log in logs")
                                    td {{new Date(log.date).toLocaleDateString()}} {{new Date(log.date).toLocaleTimeString()}}
                                    td(v-if="sync.direction == 'in'") {{log.importedRows}}
                                    td(v-if="sync.direction == 'out'") {{log.exportedRows}}
                                    td(v-if="sync.direction == 'in'") {{log.updatedProducts}}
                                    td(v-if="sync.direction == 'in'") {{log.syncedProducts}}
                                    td(v-if="sync.direction == 'in'") {{log.skippedRows}}
                                    td(v-if="sync.direction == 'out'") 
                                        font-awesome-icon(:icon="['fas', 'check-circle']", v-if="log.sentToDestination").success-sent
                                        font-awesome-icon(:icon="['fas', 'times-circle']", v-if="!log.sentToDestination").error-sent
                                    td(v-if="sync.direction == 'in'") 
                                         button.btn.customBtn
                                            a(:href="log.importedFile").white-color Download
                                    td 
                                        button.btn.customBtn
                                            a(:href="(sync.direction == 'in') ? log.logFile : log.fileSent" target="_blank").white-color Download
                                    td(v-if="sync.direction == 'in'") {{log.rowErrors}}
                                    td(v-if="sync.direction == 'out'") {{log.errors}}

                        button(@click="closeModal()").closeBtn Close this window
</template>

<script>
// import {SyncUseCaseSlim, SyncEdit} from './SyncComponents'
import SYNC_IMPORTER_LOGS from '../../../graphql/SyncImporterLogs.gql'
import SYNC_EXPORTER_LOGS from '../../../graphql/SyncExporterLogs.gql'
import {APIManager} from '../../../helpers'
export default {
  name: 'LogsModal',
  props:{
      sync: Object
  },
  components: {
  },
  data() {
    return {
        error: null,
        loading: true,
        logs: [],
        params: {
            id: "",
            description: ""
        },
    }
  },
  mounted() {
      this.loadData();
  },
  methods: {
      loadData(){
          // If current sync is direction "out" use exporter, else importer logs
          if(this.sync.direction == 'in'){
                this.$apollo.query({
                    // Query
                    query: SYNC_IMPORTER_LOGS,
                    variables: {
                        syncId: this.sync.id
                    }
                })
                .then(
                    (response) => {
                        this.logs = APIManager.prepareData(response.data.smartsyncSyncImporterLogs, false)
                        this.loading = false;
                    }, (error) => {
                        console.log(error)
                        this.error = "An error occoured during processing your request."  
                        this.loading = false;
                })
          } 

          if(this.sync.direction == 'out'){
                this.$apollo.query({
                    // Query
                    query: SYNC_EXPORTER_LOGS,
                    variables: {
                        syncId: this.sync.id
                    }
                })
                .then(
                    (response) => {
                        this.logs = APIManager.prepareData(response.data.smartsyncSyncExporterLogs, false)
                        this.loading = false;
                    }, (error) => {
                        console.log(error)
                        this.error = "An error occoured during processing your request."  
                        this.loading = false;
                })
          }
      },
      closeModal(){
          this.$emit('close');
      }
  },
  computed: {
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url('@/less/global.less');
th {
    position: sticky;
}
.white-color {
    color: white;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-height: 900px;
  overflow-y:scroll;
  width: 87%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .5s;
}

.closeBtn {
    color: gray;
    font-weight: bold;
    text-decoration: none;
    background: none;
    border: none;
}

.customBtn {
    background-color: @primary;
    color: white;
}

.success-sent {
    color: green;
}

.error-sent {
    color: red;
}
</style>
